module.exports = __webpack_public_path__ + "img/demos.7fef3519.png";